export function init() {
  function productListSlickSettings(asNavForSettings) {
    return {
      infinite: false,
      speed: 300,
      arrows: true,
      variableWidth: false,
      useCSS: true,
      useTransform: false,
      asNavFor: asNavForSettings,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
  }
  window.productListSlickSettings = productListSlickSettings;

  function productListSlickThumbsSettings(asNavForSettings) {
    return {
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      variableWidth: false,
      slidesToScroll: 1,
      useCSS: true,
      useTransform: false,
      asNavFor: asNavForSettings,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: window.decathlon.uxBreakpoints.smMin,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
      ],
    };
  }
  window.productListSlickThumbsSettings = productListSlickThumbsSettings;

  function slickProductsSlider() {
    window.decathlon.tools.slickReinitSlider(
      '.pl-element',
      '.slick-product',
      '.slick-thumbs',
      window.productListSlickSettings,
      productListSlickThumbsSettings
    );

    /* REFRESH THE PRICES FOR THE SLIDER ON PRODUCT LISTING. */
    $('.slick-product').on('afterChange', (event, slick, currentSlide) => {
      const elSlide = $(slick.$slides[currentSlide]);

      /* New sticker handler */
      if (
        elSlide.data('sticker') &&
        elSlide.data('sticker').stickerContents &&
        elSlide.data('sticker').stickerContents.length > 0
      ) {
        cube.sticker.dynamicStickerHandler(
          elSlide.data('sticker').stickerContents,
          this.closest('.pl-element').querySelector('.pl-banner')
        );
      } else {
        // Legacy
        const modelSticker = elSlide.data('model-sticker');
        $(this)
          .parents('.pl-element')
          .find('.pl-banner').textContent = '';
        $(this)
          .parents('.pl-element')
          .find('.pl-banner')
          .html(modelSticker);
      }

      elSlide.PricingPlugin(
        'fetchLatestPrice',
        elSlide.data('productRepositoryId'),
        elSlide.data('fetchFlag'),
        elSlide.data('model'),
        elSlide.data('dropPrice'),
        elSlide.data('sticker'),
        elSlide.data('section'),
        elSlide.data('idProduct'),
        elSlide.data('priceSku'),
        elSlide.data('modelReference'),
        elSlide.data('uniformPrice'),
        true
      );
    });

    /* REFRESH THE SLICK SLIDERS POSITIONS ON DEVICE ORIENTATION CHANGES */
    $(window).on('orientationchange', () => {
      setTimeout(() => {
        $('#product-list')
          .find('.slick-initialized')
          .each(() => {
            $(this).slick('setPosition');
          });
      }, 1000);
    });
  }
  window.slickProductsSlider = slickProductsSlider;
  window.slickProductsSlider();
}



// WEBPACK FOOTER //
// ./src/catalog/product-list/spotlights-slicks.js